module.exports = __webpack_public_path__ + "img/ic-addnewservice.5b49585.svg";